import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// components
import Appointment from './_Appointment';
import { PanelBody } from '../../shared/_panel';

class IndexRow extends React.Component {
  static propTypes = {
    appointment:  PropTypes.instanceOf(Immutable.Map),
    appointments: PropTypes.instanceOf(Immutable.Map),
    book:         PropTypes.instanceOf(Immutable.Map),
    date:         PropTypes.instanceOf(moment),
    rep:          PropTypes.instanceOf(Immutable.Map)
  };

  render() {
    const { date } = this.props;

    return (
      <div>
        <div className='rep-apts-index__list__header'>
          { date.format('MMM D, YYYY') }
        </div>
        <PanelBody className='rep-apts-index__list__container'>
          { this._renderAppointments() }
        </PanelBody>
      </div>
    );
  }

  // private

  _renderAppointments() {
    const { appointments, officeId } = this.props;

    const result    = (this.props.appointment || Immutable.Map()).get('result') || Immutable.List();
    const elements  = [];

    const items = appointments.sort((a, b) => {
      const segmentA = a.get('segmentNumber');
      const segmentB = b.get('segmentNumber');

      let value = 0;

      if (segmentA < segmentB) {
        value = -1;
      } else if (segmentA > segmentB) {
        value = 1;
      }

      return value;
    });

    items.forEach((item) => {
      const { book } = this.props;
      const scheduledOn = moment(item.get('scheduledOn'), 'YYYY-MM-DD').startOf('day').add(item.get('from'), 'seconds');

      if (result.includes(item.get('id'))) {
        const rep = this.props.rep.getIn(['data', item.get('rep')], Immutable.Map());

        elements.push(
          <Appointment book={ book }
            id={ item.get('id') }
            key={ item.get('id') }
            officeId={ officeId }
            rep={ rep }
            scheduledOn={ scheduledOn }
            status={ item.get('status') } />
        );
      }
    });

    return elements;
  }
}

const mapStateToProps = (state) => {
  return {
    appointment: state.get('appointment'),
    rep: state.get('rep', Immutable.Map())
  };
};

export default connect(mapStateToProps)(IndexRow);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_IndexRow.jsx